import React, { useState, useRef, useEffect } from "react";
import { Link } from "gatsby";
import { Row, Col, Container, Card } from "react-bootstrap";
import ScrollAnimation from "react-animate-on-scroll";
import Slider from "react-slick";
import parse from 'html-react-parser';

import { NewsDate } from "../common/site/functions"
import ImageTransform from "../common/ggfx-client/module/components/image-transform";
import { CASE_STUDIES_PAGE_URL } from "../common/site/constants"


import { inViewOptions, contentItemStagger, contentItem, fadeInFromTop } from '../utils/animation';

import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

function LatestCaseStudies(props) {

    const settings = {
        dots: true,
        speed: 800,
        slidesToShow: 3,
        slidesToScroll: 2,
        infinite: false,
        arrows: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },

            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },

            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },

            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },

            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
        ],
    };

    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => (
                <motion.section
                    className="guides-section-list more-similar-news latest-case-study-list"
                    ref={ref}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={contentItemStagger}

                >
                    <Container>
                        <Row className="head">
                            {props.Case_Studies_Heading &&
                                <Col xs={6} lg={12}>
                                    <motion.span variants={contentItem} className="sub-title">
                                        {props.Case_Studies_Heading}
                                    </motion.span>
                                </Col>
                            }
                            <Col xs={6} className="mobile-link">
                                <Link to={CASE_STUDIES_PAGE_URL.alias} class="link-text d-lg-none"><span>View More</span><i class="icon-arrow"></i></Link>
                            </Col>

                            <Col lg={8}>
                                <motion.div variants={fadeInFromTop} className="block-heading">
                                    <h2>{props.Case_Studies_Title}</h2>
                                </motion.div>
                            </Col>
                            <Col lg={4}>
                                <Link to={CASE_STUDIES_PAGE_URL.alias} class="link-text desktop"><span>More Case Studies</span><i class="icon-arrow"></i></Link>
                            </Col>
                        </Row>

                        <Slider {...settings} className="guide-tile-slide">
                            {props.Select_Case_Studies_to_Show && props.Select_Case_Studies_to_Show.slice(0,3).map((item, index) => {
                                const image_url = item.Tile_Image?.url;

                                let processedImages = JSON.stringify({});
                                if (item.imagetransforms?.Tile_Image_Transforms) {
                                    processedImages = item.imagetransforms.Tile_Image_Transforms;
                                }
                                return (
                                    <Link to={`${CASE_STUDIES_PAGE_URL.alias}/${item.URL}`}>
                                        <motion.div key={index} custom={index + 1} variants={fadeInFromTop} className="guide">
                                            <div className="img-zoom">
                                            <ImageTransform
                                            imagesources={image_url}
                                            renderer="srcSet"
                                            imagename="case-studies.Tile_Image.tile_1"
                                            attr={{ alt: '', class: '' }}
                                            imagetransformresult={processedImages}
                                            id={item.id}
                                            />
                                                {/* <img src={item.Tile_Image.url} alt={item.Tile_Image.alternativeText} /> */}
                                            </div>
                                            <p className="title"><span>{item.Title}</span></p>
                                            <p className="date">{item.Address}</p>
                                        </motion.div>
                                    </Link>
                                )
                            })}
                        </Slider>

                    </Container>
                </motion.section>
            )}
        </InView>
    )
}

export default LatestCaseStudies;
